/* The source page's own behaviour scripts (tracking, CheckoutChamp runtime and third-party players removed). */

  /* Rolling countdown to the next local midnight (live HRS:MIN:SEC). */
  (function () {
	var fields = {
	  hours: document.querySelectorAll('[data-countdown="hours"]'),
	  minutes: document.querySelectorAll('[data-countdown="minutes"]'),
	  seconds: document.querySelectorAll('[data-countdown="seconds"]')
	};
	function pad(n) {
	  return (n < 10 ? '0' : '') + n;
	}
	function set(nodes, value) {
	  for (var i = 0; i < nodes.length; i++) {
		nodes[i].textContent = pad(value);
	  }
	}
	function tick() {
	  var now = new Date();
	  var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
	  var diff = Math.max(0, end - now);
	  set(fields.hours, Math.floor(diff / 3600000));
	  set(fields.minutes, Math.floor((diff % 3600000) / 60000));
	  set(fields.seconds, Math.floor((diff % 60000) / 1000));
	}
	tick();
	setInterval(tick, 1000);
  }
  )();
  /* Keep the CHECK AVAILABILITY bar pinned to the viewport.
	 position:fixed is cancelled by any ancestor with transform / filter /
	 perspective / will-change / contain, because that ancestor becomes the
	 containing block. If the page shell has one, move the bar to <body>. */
  (function () {
	function pin() {
	  var bar = document.querySelector('.lst-sticky');
	  if (!bar || bar.parentElement === document.body) return;
	  for (var n = bar.parentElement; n && n !== document.body; n = n.parentElement) {
		var cs = getComputedStyle(n);
		if (
		  cs.transform !== 'none' ||
		  cs.filter !== 'none' ||
		  cs.perspective !== 'none' ||
		  cs.contain !== 'none' ||
		  /transform|filter|perspective/.test(cs.willChange)
		) {
		  document.body.appendChild(bar);
		  return;
		}
	  }
	}
	if (document.readyState === 'loading') {
	  document.addEventListener('DOMContentLoaded', pin);
	}
	else {
	  pin();
	}
	window.addEventListener('load', pin);
  }
  )();

;

            window.addEventListener('load', (function(){
                $("#loading").hide();
                $("body").removeClass("dom-pending");

                var lazyLoadThrottleTimeout;
                function recursiveOffsetParentTop(img) {
                    if (img.offsetParent) {
                        return img.offsetParent.offsetTop + recursiveOffsetParentTop(img.offsetParent);
                    } else {
                        return 0;
                    }
                }
                function lazyLoad() {
                    if (lazyLoadThrottleTimeout) {
                        clearTimeout(lazyLoadThrottleTimeout);
                    }
                    lazyLoadThrottleTimeout = setTimeout(function () {
                        const scrollTop = window.pageYOffset;
                        const buffer = 500;
                        var loaded = true;
                        //Lazy loading the images
                        var lazyLoad = [].slice.call(document.querySelectorAll(".fk-lazy"));
                        lazyLoad.forEach(function (element) {
                            if ($(element).is(':visible') && element.offsetTop + recursiveOffsetParentTop(element) < ((window.innerHeight + scrollTop) + buffer)) {
								if(element.dataset.src) {
                                    element.src = element.dataset.src;
                                }
								element.classList.remove("fk-lazy");
                            } else {
                                loaded = false;
                            }
                        });
                        if (loaded) {
                            document.removeEventListener("scroll", lazyLoad);
                            window.removeEventListener("resize", lazyLoad);
                            window.removeEventListener("orientationChange", lazyLoad);
                        }
                    }, 20);
                }

                document.addEventListener("scroll", lazyLoad);
                window.addEventListener("resize", lazyLoad);
                window.addEventListener("orientationChange", lazyLoad);
                lazyLoad();
            }), false);
        